import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MojoHasPrivilegesGuard } from 'mojo-privileges';

import { UploadModalContainerComponent } from './containers';
import { uploadConfig } from './upload.config';

export const modalRoutes: Routes = [
  {
    outlet: 'modal',
    path: 'attachments',
    canActivate: [MojoHasPrivilegesGuard],
    data: {
      privileges: [uploadConfig.privileges.candidates.edit],
    },
    component: UploadModalContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(modalRoutes)],
  exports: [RouterModule],
})
export class CandidateUploadRoutingModule {}
